import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { messages } from './messages';
import style from './styles.module.less';
import ItemDisplayImage from '../../../../../../../../components/line-item/components/item-image.component';

import type { CellProps } from './types';

const ImageCell = ({ row }: CellProps) => {
  const item = row.original;

  if (!item.productThumbnailUrl) {
    return null;
  }

  return <ItemDisplayImage className={style['item-image']} name={item.name} productThumbnailUrl={item.productThumbnailUrl} />;
};

export const createImageColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'image',
  Header: <FormattedMessage {...messages.imageColumnHeader} />,
  Cell: memo(ImageCell),
  className: style['centered-cell'],
});
